const collections = [
  { title: '院线新片速递', count: '42部', desc: '当月最新院线及网络首发影片', icon: 'ri-film-line' },
  { title: '高分电视剧合集', count: '68部', desc: '豆瓣高分电视剧一网打尽', icon: 'ri-tv-line' },
  { title: '日韩热播剧场', count: '55部', desc: '最新日剧韩剧追更专区', icon: 'ri-global-line' },
  { title: '国产精品特辑', count: '89部', desc: '精选国产电影电视剧佳作', icon: 'ri-flag-2-line' },
  { title: '欧美大片专场', count: '73部', desc: '好莱坞及欧美热门影片', icon: 'ri-earth-fill' },
  { title: '少儿动画乐园', count: '36部', desc: '适合全家观看的动画内容', icon: 'ri-emotion-line' },
  { title: '纪录片精选集', count: '51部', desc: 'BBC、NHK等经典纪录片', icon: 'ri-camera-lens-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            专题合集
          </h2>
          <p className="mt-2 text-sm text-foreground-500 font-label">按分类快速找到你想看的影视内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {collections.map((item) => (
            <a
              key={item.title}
              href="#topics"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-start gap-4 p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300 flex-shrink-0">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="font-heading font-semibold text-base text-foreground-800 group-hover:text-accent-700 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 font-label mt-1">{item.desc}</p>
                <span className="inline-block mt-2 px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-label">
                  {item.count}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}